import React from 'react';
import { Image } from 'antd';

const CustomizedImage = ({ ...restProps }) => (
  <Image preview={false} {...restProps} />
);

export default CustomizedImage;
